// src/components/Admin/Investigations/InvestigationsTable.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InvestigationItem } from '../../../api/investigationsAdminService';

interface Props {
  items: InvestigationItem[];
  selectedId: string | null;
  onSelect: (inv: InvestigationItem) => void;
}

const InvestigationsTable: React.FC<Props> = ({ items, selectedId, onSelect }) => {
  const { t } = useTranslation();

  return (
    <div className="h-[72vh] overflow-y-auto rounded-xl shadow ring-1 ring-gray-200 bg-white">
      <table className="min-w-full text-sm">
        <thead className="sticky top-0 bg-gray-100 text-gray-700 text-xs uppercase tracking-wide">
          <tr>
            <th className="px-4 py-3 text-left">{t('admin.company')}</th>
            <th className="px-4 py-3 text-left">{t('admin.comments')}</th>
            <th className="px-4 py-3 text-center">{t('admin.domains')}</th>
            <th className="px-4 py-3 text-center">{t('admin.urls')}</th>
            <th className="px-4 py-3 text-center">{t('admin.created')}</th>
          </tr>
        </thead>
        <tbody>
          {items.map((inv, idx) => (
            <tr
              key={inv.id}
              onClick={() => onSelect(inv)}
              className={`
                cursor-pointer
                ${idx % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                ${
                  inv.id === selectedId
                    ? 'bg-blue-50 ring-2 ring-inset ring-blue-400 border-l-4 border-blue-600'
                    : 'hover:bg-gray-100'
                }
              `}
            >
              <td className="px-4 py-2 font-medium">{inv.company_name}</td>
              <td className="px-4 py-2 truncate max-w-[12rem]">
                {inv.comments?.trim() || '—'}
              </td>
              <td className="px-4 py-2 text-center">{inv.domains.length}</td>
              <td className="px-4 py-2 text-center">{inv.urls.length}</td>
              <td className="px-4 py-2 text-center">
                {new Date(inv.created_at).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default InvestigationsTable;
